import { MODULE_PATHS } from '../../services/language/language.service';
import { ModalNamesToPaths } from '../../models/Modal.model';

// TODO add modal names here
export enum ModalName {
    dummyName = 'dummy-modal',
    addUser = 'add-user-modal',
    deleteUser = 'delete-user-modal',
    deleteProject = 'delete-project-modal',
    deleteContact = 'delete-contact-modal',
    addClient = 'add-client-modal',
    editClientPersonalisation = 'client-edit-personalisation-modal',
    addEditContact = 'add-edit-contact-modal',
    addDepartment = 'add-department-modal',
    editDepartment = 'edit-department-modal',
    deleteDepartment = 'delete-department-modal',
    addEditWorkingPoint = 'add-edit-working-point-modal',
    deleteWorkingPoint = 'delete-working-point-modal',
    addWorkingPointActivity = 'add-working-point-activity-modal',
    deleteWorkingPointActivity = 'delete-working-point-activity-modal',
    addWorkingPointCaen = 'add-working-point-caen-modal',
    deleteWorkingPointCaen = 'delete-working-point-caen-modal',
    addEditVisit = 'add-edit-visit-modal',
    deleteVisit = 'delete-visit-modal',
    addTask = 'add-task-modal',
    editTask = 'edit-task-modal',
    deleteTask = 'delete-task-modal',
    deleteContract = 'delete-contract-modal',
    duplicateContract = 'duplicate-contract-modal',
    addEditContract = 'add-edit-contract-modal',
    deleteAnnex = 'delete-annex-modal',
    addEditContractDocument = 'add-edit-contract-document-modal',
    editContractDocumentService = 'edit-contract-document-service-modal',
    addContractDocumentService = 'add-contract-document-service-modal',
    addContractDocumentPackage = 'add-contract-document-package-modal',
    deleteContractDocumentService = 'delete-contract-document-service-modal',
    deleteMeter = 'delete-meter-modal',
    deleteEquipment = 'delete-equipment-modal',
    deleteSpace = 'delete-space-modal',
    deleteSupplier = 'delete-supplier-modal',
    deleteTenant = 'delete-tenant-modal',
    addOrganisation = 'add-organisation-modal',
    deleteOrganisation = 'delete-organisation-modal',
    deleteIntervention = 'delete-intervention-modal',
    gallery = 'gallery-modal',
    deleteFeedback = 'delete-feedback-modal',
    confirmation = 'confirmation-modal',
    addGroup = 'add-group-modal',
    editGroup = 'edit-group-modal',
    deleteGroup = 'delete-group-modal',
    addCategory = 'add-category-modal',
    editCategory = 'edit-category-modal',
    deleteCategory = 'delete-category-modal',
    addSubcategory = 'add-subcategory-modal',
    editSubcategory = 'edit-subcategory-modal',
    deleteSubcategory = 'delete-subcategory-modal',
    addActivity = 'add-activity-modal',
    editActivity = 'edit-activity-modal',
    deleteActivity = 'delete-activity-modal',
    addSignerFunction = 'add-signer-function-modal',
    editSignerFunction = 'edit-signer-function-modal',
    deleteSignerFunction = 'delete-signer-function-modal',
    addZone = 'add-zone-modal',
    editZone = 'edit-zone-modal',
    deleteZone = 'delete-zone-modal',
    editPermissions = 'edit-permissions-modal',
    editService = 'edit-service-modal',
    addPackage = 'add-package-modal',
    editPackage = 'edit-package-modal',
    deletePackage = 'delete-package-modal',
    addSsmResponsible = 'add-ssm-responsible-modal',
    addPosition = 'add-position-modal',
    editPosition = 'edit-position-modal',
    addSession = 'add-session-modal',
    deleteSession = 'delete-session-modal',
    addSessionEmployees = 'add-session-employees-modal',
    deleteSessionEmployee = 'delete-session-employee-modal',
    prepareSession = 'prepare-session-modal',
    editTrainingTemplate = 'edit-training-template-modal',
    deleteTrainingTemplateGroup = 'delete-training-template-group-modal',
    addEditTrainingTemplateQuestion = 'add-edit-training-template-question-modal',
    addEditTrainingTemplateAnswer = 'add-edit-training-template-answer-modal',
};

export const MODAL_NAMES_TO_PATHS: ModalNamesToPaths = {
    [MODULE_PATHS.CLIENTS]: {
        [ModalName.deleteContact]: () => {
            return import('../../../_pages/clients/components/delete-contact-modal/delete-contact-modal.component');
        },
        [ModalName.addClient]: () => {
            return import('../../../_pages/clients/components/add-client-modal/add-client-modal.component');
        },
        [ModalName.editClientPersonalisation]: () => {
            return import('../../../_pages/clients/components/client-edit-personalisation-modal/client-edit-personalisation-modal.component');
        },
        [ModalName.addEditContact]: () => {
            return import('../../../_pages/clients/components/add-edit-contact-modal/add-edit-contact-modal.component');
        },
        [ModalName.addDepartment]: () => {
            return import('../../../_pages/clients/components/add-department-modal/add-department-modal.component');
        },
        [ModalName.editDepartment]: () => {
            return import('../../../_pages/clients/components/edit-department-modal/edit-department-modal.component');
        },
        [ModalName.deleteDepartment]: () => {
            return import('../../../_pages/clients/components/delete-department-modal/delete-department-modal.component');
        },
        [ModalName.addEditWorkingPoint]: () => {
            return import('../../../_pages/clients/components/add-edit-working-point-modal/add-edit-working-point-modal.component');
        },
        [ModalName.deleteWorkingPoint]: () => {
            return import('../../../_pages/clients/components/delete-working-point-modal/delete-working-point-modal.component');
        },
        [ModalName.addWorkingPointActivity]: () => {
            return import('../../../_pages/clients/components/add-working-point-activity-modal/add-working-point-activity-modal.component');
        },
        [ModalName.deleteWorkingPointActivity]: () => {
            return import('../../../_pages/clients/components/delete-working-point-activity-modal/delete-working-point-activity-modal.component');
        },
        [ModalName.addWorkingPointCaen]: () => {
            return import('../../../_pages/clients/components/add-working-point-caen-modal/add-working-point-caen-modal.component');
        },
        [ModalName.deleteWorkingPointCaen]: () => {
            return import('../../../_pages/clients/components/delete-working-point-caen-modal/delete-working-point-caen-modal.component');
        },
        [ModalName.addEditVisit]: () => {
            return import('../../../_pages/clients/components/add-edit-visit-modal/add-edit-visit-modal.component');
        },
        [ModalName.deleteVisit]: () => {
            return import('../../../_pages/clients/components/delete-visit-modal/delete-visit-modal.component');
        },
        [ModalName.addTask]: () => {
            return import('../../../_pages/clients/components/add-task-modal/add-task-modal.component');
        },
        [ModalName.editTask]: () => {
            return import('../../../_pages/clients/components/edit-task-modal/edit-task-modal.component');
        },
        [ModalName.deleteTask]: () => {
            return import('../../../_pages/clients/components/delete-task-modal/delete-task-modal.component');
        },
        [ModalName.deleteContract]: () => {
            return import('../../../_pages/clients/components/delete-contract-modal/delete-contract-modal.component');
        },
        [ModalName.duplicateContract]: () => {
            return import('../../../_pages/clients/components/duplicate-contract-modal/duplicate-contract-modal.component');
        },
        [ModalName.addEditContract]: () => {
            return import('../../../_pages/clients/components/add-edit-contract-modal/add-edit-contract-modal.component');
        },
        [ModalName.deleteAnnex]: () => {
            return import('../../../_pages/clients/components/delete-annex-modal/delete-annex-modal.component');
        },
        [ModalName.addEditContractDocument]: () => {
            return import('../../../_pages/clients/components/add-edit-contract-document-modal/add-edit-contract-document-modal.component');
        },
        [ModalName.editContractDocumentService]: () => {
            return import('../../../_pages/clients/components/edit-contract-document-service-modal/edit-contract-document-service-modal.component');
        },
        [ModalName.addContractDocumentService]: () => {
            return import('../../../_pages/clients/components/add-contract-document-service-modal/add-contract-document-service-modal.component');
        },
        [ModalName.addContractDocumentPackage]: () => {
            return import('../../../_pages/clients/components/add-contract-document-package-modal/add-contract-document-package-modal.component');
        },
        [ModalName.deleteContractDocumentService]: () => {
            return import('../../../_pages/clients/components/delete-contract-document-service-modal/delete-contract-document-service-modal.component');
        }
    },
    [MODULE_PATHS.TRAINING]: {
        [ModalName.confirmation]: () => {
            return import('../../../_pages/training/components/confirmation-modal/confirmation-modal.component');
        }
    },
    [MODULE_PATHS.SSM]: {
        [ModalName.addSession]: () => {
            return import('../../../_pages/ssm/components/add-session-modal/add-session-modal.component');
        },
        [ModalName.deleteSession]: () => {
            return import('../../../_pages/ssm/components/delete-session-modal/delete-session-modal.component');
        },
        [ModalName.addSessionEmployees]: () => {
            return import('../../../_pages/ssm/components/add-session-employees-modal/add-session-employees-modal.component');
        },
        [ModalName.deleteSessionEmployee]: () => {
            return import('../../../_pages/ssm/components/delete-session-employee-modal/delete-session-employee-modal.component');
        },
        [ModalName.prepareSession]: () => {
            return import('../../../_pages/ssm/components/prepare-session-modal/prepare-session-modal.component');
        },
        [ModalName.editTrainingTemplate]: () => {
            return import('../../../_pages/ssm/components/edit-training-template-modal/edit-training-template-modal.component');
        },
        [ModalName.deleteTrainingTemplateGroup]: () => {
            return import('../../../_pages/ssm/components/delete-training-template-group-modal/delete-training-template-group-modal.component');
        },
        [ModalName.addEditTrainingTemplateQuestion]: () => {
            return import('../../../_pages/ssm/components/add-edit-training-template-question-modal/add-edit-training-template-question-modal.component');
        },
        [ModalName.addEditTrainingTemplateAnswer]: () => {
            return import('../../../_pages/ssm/components/add-edit-training-template-answer-modal/add-edit-training-template-answer-modal.component');
        },
    },
    [MODULE_PATHS.ADMIN]: {
        [ModalName.dummyName]: () => {
            return import('../../../_pages/admin/components/dummy-modal/dummy-modal.component');
        },
        [ModalName.addUser]: () => {
            return import('../../../_pages/admin/components/add-user-modal/add-user-modal.component');
        },
        [ModalName.deleteUser]: () => {
            return import('../../../_pages/admin/components/delete-user-modal/delete-user-modal.component');
        },
        [ModalName.addGroup]: () => {
            return import('../../../_pages/admin/components/add-group-modal/add-group-modal.component');
        },
        [ModalName.editGroup]: () => {
            return import('../../../_pages/admin/components/edit-group-modal/edit-group-modal.component');
        },
        [ModalName.deleteGroup]: () => {
            return import('../../../_pages/admin/components/delete-group-modal/delete-group-modal.component');
        },
        [ModalName.addCategory]: () => {
            return import('../../../_pages/admin/components/add-category-modal/add-category-modal.component');
        },
        [ModalName.editCategory]: () => {
            return import('../../../_pages/admin/components/edit-category-modal/edit-category-modal.component');
        },
        [ModalName.deleteCategory]: () => {
            return import('../../../_pages/admin/components/delete-category-modal/delete-category-modal.component');
        },
        [ModalName.addSubcategory]: () => {
            return import('../../../_pages/admin/components/add-subcategory-modal/add-subcategory-modal.component');
        },
        [ModalName.editSubcategory]: () => {
            return import('../../../_pages/admin/components/edit-subcategory-modal/edit-subcategory-modal.component');
        },
        [ModalName.deleteSubcategory]: () => {
            return import('../../../_pages/admin/components/delete-subcategory-modal/delete-subcategory-modal.component');
        },
        [ModalName.addActivity]: () => {
            return import('../../../_pages/admin/components/add-activity-modal/add-activity-modal.component');
        },
        [ModalName.editActivity]: () => {
            return import('../../../_pages/admin/components/edit-activity-modal/edit-activity-modal.component');
        },
        [ModalName.deleteActivity]: () => {
            return import('../../../_pages/admin/components/delete-activity-modal/delete-activity-modal.component');
        },
        [ModalName.addSignerFunction]: () => {
            return import('../../../_pages/admin/components/add-signer-function-modal/add-signer-function-modal.component');
        },
        [ModalName.editSignerFunction]: () => {
            return import('../../../_pages/admin/components/edit-signer-function-modal/edit-signer-function-modal.component');
        },
        [ModalName.deleteSignerFunction]: () => {
            return import('../../../_pages/admin/components/delete-signer-function-modal/delete-signer-function-modal.component');
        },
        [ModalName.addZone]: () => {
            return import('../../../_pages/admin/components/add-zone-modal/add-zone-modal.component');
        },
        [ModalName.editZone]: () => {
            return import('../../../_pages/admin/components/edit-zone-modal/edit-zone-modal.component');
        },
        [ModalName.deleteZone]: () => {
            return import('../../../_pages/admin/components/delete-zone-modal/delete-zone-modal.component');
        },
        [ModalName.editPermissions]: () => {
            return import('../../../_pages/admin/components/edit-permissions-modal/edit-permissions-modal.component');
        },
        [ModalName.editService]: () => {
            return import('../../../_pages/admin/components/edit-service-modal/edit-service-modal.component');
        },
        [ModalName.addPackage]: () => {
            return import('../../../_pages/admin/components/add-package-modal/add-package-modal.component');
        },
        [ModalName.editPackage]: () => {
            return import('../../../_pages/admin/components/edit-package-modal/edit-package-modal.component');
        },
        [ModalName.deletePackage]: () => {
            return import('../../../_pages/admin/components/delete-package-modal/delete-package-modal.component');
        },
        [ModalName.addSsmResponsible]: () => {
            return import('../../../_pages/admin/components/add-ssm-responsible-modal/add-ssm-responsible-modal.component');
        },
        [ModalName.addPosition]: () => {
            return import('../../../_pages/admin/components/add-position-modal/add-position-modal.component');
        },
        [ModalName.editPosition]: () => {
            return import('../../../_pages/admin/components/edit-position-modal/edit-position-modal.component');
        }
    }
};